import InfoIcon from 'components/ReusableComponents/Icons/Info'
import { useInternalAdmin } from 'hooks'
import moment from 'moment'
import { useEffect } from 'react'
import { useState } from 'react'
import hotelApi from 'services/api/hotel'

import styles from './OnHoldWarning.module.scss'

const OnHoldWarning = () => {
  const [inviteBackDisableReason, setInviteBackDisableReason] = useState('')
  const [inviteBackDisabledOn, setInviteBackDisabledOn] = useState('')
  const [inviteBackDisabledBy, setInviteBackDisabledBy] = useState('')

  const [isLoading, setIsLoading] = useState(true)

  const isInternalAdmin = useInternalAdmin()

  useEffect(() => {
    hotelApi.getDetails().then(res => {
      const {
        subsidiary: {
          inviteBackDisableReason,
          inviteBackDisabledOn,
          inviteBackDisabledBy
        }
      } = res

      setInviteBackDisableReason(inviteBackDisableReason)
      setInviteBackDisabledOn(inviteBackDisabledOn)
      setInviteBackDisabledBy(inviteBackDisabledBy)
      setIsLoading(false)
    })
  }, [])

  if (isLoading) {
    return null
  }

  return (
    <div className={styles.onHoldWarning}>
      <InfoIcon />
      Automated invites are temporarily on hold "{inviteBackDisableReason}" on{' '}
      {moment(inviteBackDisabledOn).format('MMM D, YYYY')}
      {isInternalAdmin && <> by {inviteBackDisabledBy}</>}.
    </div>
  )
}

export default OnHoldWarning
